// sw-client.js
// Lógica para registrar o service worker e garantir reload apenas após controllerchange

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        // Função para enviar skipWaiting para o SW
        function sendSkipWaiting() {
          if (registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });

            // Aguarda controllerchange antes de dar reload
            navigator.serviceWorker.addEventListener('controllerchange', function reloadOnActivate() {
              window.location.reload();
              navigator.serviceWorker.removeEventListener('controllerchange', reloadOnActivate);
            });
          }
        }

        // Exemplo: disparar skipWaiting automaticamente se SW está waiting
        if (registration.waiting) {
          sendSkipWaiting();
        }

        // Opcional: expor função global para uso manual
        window.triggerSkipWaiting = sendSkipWaiting;
      })
      .catch(error => {
        console.error('Erro ao registrar service worker:', error);
      });
  });
}
